import './addons-group';
import './top-banner';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import variables
import './variables.scss';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

/**
 * Web component representing the addons page
 *
 * @augments LitElement
 */
@customElement( 'uap-page-addons' ) // eslint-disable-line require-jsdoc
export class AutomatorPageAddons extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Renders the component
	 *
	 * @return {TemplateResult|undefined} The template
	 */
	render() {
		return html`
			<div class="page">
				<div class="page-content">
					<uap-page-addons-banner></uap-page-addons-banner>

					<div class="page-content-inner">
						<div class="page-content-section">
							<h2>
								${ escapeHTML( _x( 'License summary', 'Addons', 'uncanny-automator' ) ) }
							</h2>
							<uo-license-summary
								.filterData=${ data => {
									// Check the scenario ID and modify the data accordingly
									switch ( data.scenario_id ) {
										case 'pro-not-installed':
											// Define the type and content of the notice
											data.notice.type = 'warning';
											data.notice.content = escapeHTML( __( "It looks like you're using the Lite plan, which **doesn't include addons**. **Upgrade** to Automator Pro to get access to all addon features.", 'uncanny-automator' ) );
											break;

										case 'pro-installed-but-deactivated':
											// Define the content of the notice
											data.notice.content = escapeHTML( __( "To update your addons and **gain access to the latest released addons**, you need to **activate Automator Pro**. Please activate Automator Pro to unlock these additional features.", 'uncanny-automator' ) );
											break;

										case 'pro-installed-license-active-pro-basic':
											// Define the type and content of the notice
											data.notice.type = 'warning';
											data.notice.content = escapeHTML( __( "To update your addons and **access the latest releases**, you need a **Pro Plus** or **Pro Elite** license. Please upgrade your plan to unlock these additional features.", 'uncanny-automator' ) );
											break;

										case 'pro-installed-license-active-pro-plus':
											// Define the content of the notice
											data.notice.content = escapeHTML( __( "Great news—your Pro Plus license already **grants you access to some of our most popular addons**. With more features at your fingertips, you're well on your way to automating like a pro. Ready for the next level? Upgrade to **Pro Elite** for complete access to our entire addon library!", 'uncanny-automator' ) );
											break;

										case 'pro-installed-license-active-pro-elite':
											// Define the content of the notice
											data.notice.content = escapeHTML( __( "Your Pro Elite license gives you **complete access to every addon** we offer, ensuring the most powerful and versatile automation experience. Explore it all, and **let your creativity run wild**!", 'uncanny-automator' ) );
											break;

										case 'pro-installed-license-inactive':
										case 'pro-installed-license-expired':
										case 'pro-installed-license-disabled':
										case 'pro-installed-license-site-inactive':
										case 'pro-installed-license-invalid':
											// Define the content of the notice
											data.notice.content = escapeHTML( __( "To update your addons and **gain access to the latest released addons**, you need an **active Pro license**. Please get a Pro license to gain access to these features.", 'uncanny-automator' ) );
											break;
									}

									return data;
								} }
							></uo-license-summary>
						</div>

						<div class="page-content-section">
							<h2>
								${ escapeHTML( _x( 'Only available in Plus and higher', 'Addons', 'uncanny-automator' ) ) }
							</h2>

							<uap-page-addons-group
								list-code="plus"
							></uap-page-addons-group>
						</div>

						<div class="page-content-section">
							<h2>
								${ escapeHTML( _x( 'Only available in Elite', 'Addons', 'uncanny-automator' ) ) }
							</h2>

							<uap-page-addons-group
								list-code="elite"
							></uap-page-addons-group>
						</div>
					</div>
				</div>
			</div>
		`;
	}
}
